/*  ========================================================================
    # Hooks - Use Resize
    ========================================================================  */
import { useLayoutEffect } from 'react';

/**
 * Runs a callback function whenever the referenced element is resized
 */
export default function useResize(observedElement, callback) {
  useLayoutEffect(() => {
    if (observedElement.current) {
      const observer = new ResizeObserver(entries => {
        for (const entry of entries) {
          callback(entry);
        }
      });

      observer.observe(observedElement.current);

      // Cleanup function
      return () => {
        observer.disconnect();
      };
    }
  }, [observedElement, callback]);
}
